import karbonwiseLogo from "./karbonvise-logo.svg";
import palamurlogo from "./palamur-logo.svg";
import backgroundImage from "./bg.svg";
import { ReactComponent as hierarchy } from "./hierarchy.svg";
import { ReactComponent as download } from "./download.svg";
import { ReactComponent as GetStartedFormula } from "./getstartedFormula.svg";

export const assets = {
  palamurlogo,
  karbonwiseLogo,
  backgroundImage,
  hierarchy,
  download,
  GetStartedFormula,
};
